require('./emitedTransfersLiquidationView.scss');

const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const EmitedTransfersLiquidationDetails = require('components/transfers/emitedTransfersLiquidation/emitedTransfersLiquidationDetails/emitedTransfersLiquidationDetails');
const EmitedTransfersLiquidationTable = require('components/transfers/emitedTransfersLiquidation/emitedTransfersLiquidationTable/emitedTransfersLiquidationTable');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton');
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
// @ actions
const emitedTransfersLiquidations = require('actions/emitedTransfersLiquidations');
const intervenersActions = require('actions/getAccountInterveners');
// @ helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

class EmitedTransfersLiquidationView extends React.Component {
    componentWillMount() {
        const {
            history,
            immTransactions,
            match: { params: { accountId, transferId } }
        } = this.props;
        const immTransaction = immTransactions.getIn([accountId, 'byId', transferId]);
        const hasTransaction = immTransactions.hasIn([accountId, 'byId', transferId]);

        if (!hasTransaction || !immTransaction.has('details')) {
            history.push(`/myprofile/transfers/emited/${accountId}`);
        }
    }

    componentDidMount() {
        const {
            immTransactions,
            requestEmitedTransfersLiquidations,
            requestInterveners,
            match: { params: { accountId, transferId } }
        } = this.props;
        const immTransaction = immTransactions.getIn([accountId, 'byId', transferId]);

        requestEmitedTransfersLiquidations(immTransaction);
        requestInterveners(accountId);
    }

    componentWillUnmount() {
        const {
            immTransactions,
            resetInterveners,
            match: { params: { accountId, transferId} }
        } = this.props;
        const immTransaction = immTransactions.getIn([accountId, 'byId', transferId]);
        const hasTransaction = immTransactions.hasIn([accountId, 'byId', transferId]);

        if (hasTransaction && immTransaction.has('details')) {
            resetInterveners(accountId);
        }
    }

    buildLiquidationSection() {
        const {
            immAccounts,
            immScreen,
            immTransactions,
            requestEmitedTransfersLiquidations,
            match: { params: { accountId, transferId } }
        } = this.props;
        const immTransaction = immTransactions.getIn([accountId, 'byId', transferId]);
        let content;

        if (immTransaction.get('fetchingLiquidations')) {
            content = (
                <LoadingSection />
            );
        } else if (!!immTransaction.get('liquidationsError')) {
            const retryButton = (
                <OKButton onClick={() => {requestEmitedTransfersLiquidations(immTransaction)}}>
                    <FormattedText value="common-retry" />
                </OKButton>
             );

             content = (
                 <div className="emited-transfers-liquidation-view__empty-state">
                     <EmptyState primaryText={formatText('transfersLiquidationDetails-errorState')} button={retryButton} iconType="nointernet-banking"/>
                 </div>
             );
        } else if (immTransaction.get('fetchLiquidationsSuccess')) {
            content = (
                <section>
                    <EmitedTransfersLiquidationDetails
                        accountId={accountId}
                        immAccounts={immAccounts}
                        immScreen={immScreen}
                        immTransaction={immTransaction}
                    />
                    <EmitedTransfersLiquidationTable
                        accountId={accountId}
                        immAccounts={immAccounts}
                        immScreen={immScreen}
                        immTransaction={immTransaction}
                    />
                </section>
            );
        }

        return content;
    }

    render() {
        const { immAccounts, match: { params: { accountId } } } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const moreOptionsButton = (<TransfersMoreOptionsButton immAccount={immAccount} />);
        const optionsButton = (<TransfersOptionsButton immAccount={immAccount} />);
        const liquidationSection = this.buildLiquidationSection();
        const headerTitle = formatText('transfersLiquidationDetails-transferDetails');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('transfersLanding-emitedTranfers'),
                url: `/myprofile/transfers/emited/${accountId}`
            },
            {
                text: formatText('transfersLiquidationDetails-liquidationDetails')
            }
        ];


        return (
            <section className="emited-transfers-liquidation-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('transfersLiquidationDetails-liquidationDetails')}>
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <section className="row grid-view--content-position-negative">
                            <OKSectionBox>
                                <header className="emited-transfers-liquidation-view__header clearfix">
                                    <div className="pull-left">
                                        <OKBoxTitle value={headerTitle} />
                                    </div>
                                </header>
                                {liquidationSection}
                            </OKSectionBox>
                        </section>
                    </div>
                </div>
            </section>
        );
    }
}

EmitedTransfersLiquidationView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immTransactions: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    requestEmitedTransfersLiquidations: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    resetInterveners: PropTypes.func.isRequired
};

module.exports.EmitedTransfersLiquidationView = connect(
    state => ({
        immAccounts: state.accounts,
        immTransactions: state.emitedTransfers,
        immScreen: state.screen,
    }),
    {
    requestEmitedTransfersLiquidations: emitedTransfersLiquidations.requestEmitedTransfersLiquidations,
    requestInterveners: intervenersActions.requestAccountInterveners,
    resetInterveners: intervenersActions.resetAccountInterveners
})(withRouter(EmitedTransfersLiquidationView));
